import { makeRequest } from "./client";

export const templatesApi = {
  create: async (template: {
    name: string;
    title: string;
    description: string;
    background: string;
    noticeType: "info" | "custom_event";
    isUrgent?: boolean;
    audience?: string;
    targetSubcircle?: string;
    isSystemTemplate?: boolean;
  }, token: string): Promise<{
    template: {
      templateId: string;
      organizationId: string;
      name: string;
      title: string;
      description: string;
      background: string;
      noticeType: "info" | "custom_event";
      isUrgent?: boolean;
      audience?: string;
      targetSubcircle?: string;
      createdAt: string;
      updatedAt: string;
      createdBy: string;
      usageCount: number;
    };
    message: string;
  }> => {
    return makeRequest("/v1/templates", {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: JSON.stringify(template),
    });
  },

  getAll: async (token: string): Promise<{
    templates: Array<{
      templateId: string;
      organizationId: string;
      name: string;
      title: string;
      description: string;
      background: string;
      noticeType: "info" | "custom_event";
      isUrgent?: boolean;
      audience?: string;
      targetSubcircle?: string;
      createdAt: string;
      updatedAt: string;
      createdBy: string;
      usageCount: number;
    }>;
    count: number;
    message: string;
    organizationId: string;
  }> => {
    return makeRequest("/v1/templates", {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  update: async (
    templateId: string,
    template: Partial<{
      name: string;
      title: string;
      description: string;
      background: string;
      noticeType: "info" | "custom_event";
      isUrgent?: boolean;
      audience?: string;
      targetSubcircle?: string;
    }>,
    token: string
  ): Promise<{
    template: {
      templateId: string;
      organizationId: string;
      name: string;
      title: string;
      description: string;
      background: string;
      noticeType: "info" | "custom_event";
      isUrgent?: boolean;
      audience?: string;
      targetSubcircle?: string;
      createdAt: string;
      updatedAt: string;
      createdBy: string;
      usageCount: number;
    };
    message: string;
  }> => {
    return makeRequest(`/v1/templates/${templateId}`, {
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
      body: JSON.stringify(template),
    });
  },

  delete: async (templateId: string, token: string): Promise<{
    message: string;
    templateId: string;
  }> => {
    return makeRequest(`/v1/templates/${templateId}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};
